import React, { useEffect, useRef, useState } from 'react'
import { Container, Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './style.scss'
import axios from 'axios'
import { fetchStats } from '../../redux/action/stats/stats'
import { useDispatch, useSelector } from 'react-redux'
import moment from "moment-jalaali";
import { fetchFooterLinks } from '../../redux/action/stats/footerLinks'
import SimpleReactValidator from 'simple-react-validator'
import { toast } from 'react-toastify'

const lang = localStorage.getItem('lang')

const Footer = () => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [phoneNumber, setPhoneNumber] = useState('')
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const stats = useSelector(state => state.stats)
    const footer_links = useSelector(state => state.footer_links)

    useEffect(() => {
        if(!stats.stats.today_visits) {
            dispatch(fetchStats())
        }
        if(!footer_links.footer_links.length) {
            dispatch(fetchFooterLinks())
        }
    }, [])

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است",
          min:"تعداد کاراکترهای ورودی کم است"
        },
    }))

    const handleSubscribe = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            axios.post('p/subscribe', {mobile: phoneNumber})
            .then(response => {
                setBtnLoading(false)
                if(response.status === 200) {
                    setPhoneNumber('')
                    toast.dismiss()
                    toast.success(t("toast_successfully_done") , {position: 'bottom-right',className: 'foo-bar'})
                } else if (response.status === 201) {
                    setPhoneNumber('')
                    toast.dismiss()
                    toast.info(t("toast The desired number is recorded in the newsletter") , {position: 'bottom-right'})
                } else {
                    setPhoneNumber('')
                }
            })
            .catch(error => {
                console.log(error)
                setBtnLoading(false)
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            toast.dismiss()
            toast.error(t("toast Enter your mobile number") , {position: 'bottom-right'})
            validator.current.showMessages()
        }
    }

    return (
        <>
            <div className='footer-bg text-light'>
                <Container fluid>
                    <div className='row'>
                        <div className='subscribe'>
                            <h2 className='mb-4'> {t("subscribe_title")} </h2>
                            <p className='m-0 text-center'>{t("Be the first to know the latest news and announcements by subscribing to the newsletter")}</p>
                            <p className='mt-1 text-center'>{t("subscribe_phone_request")}</p>
                            <div className='subscribe-form'>
                                <Form onSubmit={handleSubscribe}>
                                    <Form.Label htmlFor="inlineFormInput" visuallyHidden>
                                    {t("nav_item_1")}
                                    </Form.Label>
                                    <Form.Control
                                        value={phoneNumber}
                                        className="mb-2 subscribe-form-input"
                                        id="inlineFormInput"
                                        placeholder={t("subscribe_input")}
                                        onChange={ e => setPhoneNumber(e.target.value)}
                                    />
                                    <span className='validator_error' style={{color: '#fd6161'}}>{validator.current.message('phoneNumber', phoneNumber, 'required|min:11')}</span>
                                    <button disabled={btnLoading ? true : false}>{t("send")}</button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </Container>
                <Container>
                    <div className='row'>
                        <div className='col-md-4 footer-content'>
                            <h6> {t("quick-access")} </h6>
                            <ul>
                                <li><Link to="/">{t("nav_logo")}</Link></li>
                                <li><Link to="/login">{t("exhibitors")}</Link></li>
                                <li><Link to="/news"> {t("news")} </Link></li>
                                <li><Link to="/announcements"> {t("announcements")} </Link></li>
                                <li><Link to="/contact-us">{t("contact-us")}</Link></li>
                                <li><Link to="/privacy">{t("privacy")}</Link></li>
                                <li><Link to="/ethics">{t("ethics")}</Link></li>
                            </ul>
                        </div>
                        {footer_links.footer_links &&
                            footer_links.footer_links.length ? 
                            <div className='col-md-4 footer-content'>
                                <h6> {t("related-websites")} </h6>
                                <ul>
                                    {footer_links.footer_links.map(link => (
                                            <li key={link.id}><a href={link.url} target="_blank">{link.title}</a></li>
                                        ))
                                    }
                                </ul>
                            </div>
                            :
                                ''
                        }
                        <div className='col-md-4 footer-content'>
                            <h6> {t("site-statistics")} </h6>
                            <div className='site-info'>
                                <div className='site-info-item'><span>{t("last-update")} : </span>
                                {lang === 'en' ? 
                                    stats.stats.last_update ? <span>{stats.stats.last_update.substr(0, 10)}</span> : '...'
                                : 
                                    stats.stats.last_update ? <span>{moment(stats.stats.last_update.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')}</span> : '...'

                                }
                                </div>
                                <div className='site-info-item'><span>{t("online-users")} : </span><span>{stats.stats.online_users ? stats.stats.online_users.toLocaleString() : '...'}</span></div>
                                <div className='site-info-item'><span>{t("today-views")} : </span><span>{stats.stats.today_visits ? stats.stats.today_visits.toLocaleString() : '...'}</span></div>
                                <div className='site-info-item'><span>{t("all-views")} : </span><span>{stats.stats.total_visits ? stats.stats.total_visits.toLocaleString() : '...'}</span></div>
                            </div>
                        </div>
                    </div>
                </Container>
                <div className="copyright">
                    <p className="text-center"> {t("all-right-reserverd")} </p>
                </div>
            </div>
        </> 
    )
}

export default Footer
